import { createFileRoute } from '@tanstack/react-router';
import { requireRole } from '@/lib/routeGuards';
import { MemberExamsPage } from '@/features/mockExams/member/MemberExamsPage';
export const Route = createFileRoute('/_authed/my-mock-exams')({
  beforeLoad: () => requireRole('student', 'parent'),
  component: MemberExamsPage,
});
